import { configureOpenApiClients } from '../../api/configure';
import { campaignsReserveCampaignAsync } from '../../api/v2';

export const useCampaignApi = (token: string) => {
  configureOpenApiClients();

  const reserveCampaign = async (order: any) =>
    await campaignsReserveCampaignAsync({
      body: order,
      headers: { authorization: 'Bearer ' + token, clientType: 'Web' },
    });

  return {
    reserveCampaign,
  };
};
